// extracted by mini-css-extract-plugin
export default {"price":"G6-z","onSale":"H6-z","msrpLabelPrice":"I6-z","msrpLabel":"J6-z","originalPrice":"K6-z","percentOff":"L6-z"};